import { Body1, Header4 } from 'structure/home/components/Typography';

interface BubbleContentProps {
  title: string;
  description: string;
}

export const BubbleContent = (props: BubbleContentProps) => {
  const { title, description } = props;

  return (
    <div className='flex flex-col gap-4'>
      <Header4 as='p' className='text-softYellow'>
        {title}
      </Header4>
      <Body1 as='p' className='text-[#C5C6C5]'>
        {description}
      </Body1>
    </div>
  );
};
